import React from 'react';
export function AboutSection() {
  return <section className="py-16 bg-gray-50" data-id="element-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-7">
          <div className="lg:w-1/2" data-id="element-8">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rXt3UC7HbRPDJRZ11vHkeH/logo1.png" alt="Fire Safety Displays logo" className="mx-auto lg:mx-0 max-w-xs" data-id="element-9" />
          </div>
          <div className="lg:w-1/2" data-id="element-10">
            <h2 className="text-3xl font-bold mb-6" data-id="element-11">
              About Fire Safety Displays
            </h2>
            <p className="text-lg text-gray-700 mb-6" data-id="element-12">
              Since 1980, the Fire Safety Displays Company has been providing
              "You are Here" evacuation displays for all different types of
              companies to meet OSHA, International Building Code, joint
              commission, fire department and other regulatory requirements.
            </p>
            <p className="text-lg text-gray-700 mb-6" data-id="element-13">
              Our mission is to help businesses across industries stay fully
              compliant and prepared with expertly crafted evacuation displays
              and comprehensive emergency identification solutions.
            </p>
            <div className="flex flex-wrap gap-8 mt-8" data-id="element-14">
              <div className="flex flex-col" data-id="element-15">
                <span className="text-4xl font-bold text-red-600" data-id="element-16">40+</span>
                <span className="text-gray-600" data-id="element-17">Years of Experience</span>
              </div>
              <div className="flex flex-col" data-id="element-18">
                <span className="text-4xl font-bold text-red-600" data-id="element-19">1980</span>
                <span className="text-gray-600" data-id="element-20">Established</span>
              </div>
              <div className="flex flex-col" data-id="element-21">
                <span className="text-4xl font-bold text-red-600" data-id="element-22">100%</span>
                <span className="text-gray-600" data-id="element-23">Regulatory Compliant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}